import ProgressCircle from './ProgressCircle';
import ProgressLine from './ProgressLine';
export default {
  Line: ProgressLine,
  Circle: ProgressCircle
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/Progress/Progress.js
// module id = 2460
// module chunks = 33